import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { Match } from 'meteor/check';

SimpleSchema.extendOptions({
	hide: Match.Optional(Boolean),
	uniforms: Match.Optional(
		Match.OneOf(
			String,
			Function,
			Match.ObjectIncluding({
				component: Match.Optional(
					Match.OneOf(
						String,
						Function
					)
				)
			})
		)
	)
});

SimpleSchema.messages({
	required: 'Le champ "[label]" est requis',
	minString: "[label] doit faire au moins [min] caractères",
	maxString: "[label] ne peut pas faire plus de [max] caractères",
	minNumber: "[label] doit être supérieur ou égal à [min]",
	maxNumber: "[label] doit être inférieur ou égal [max]",
	minDate: "[label] doit être après [min]",
	maxDate: "[label] ne peut pas être après [max]",
	badDate: "[label] n'est pas une date valide",
	minCount: "Le nombre de [label] doit être au moins de [minCount]",
	maxCount: "Le nombre de [label] doit être au plus de [maxCount]",
	noDecimal: "[label] doit être un nombre entier",
	notAllowed: "[value] n'est pas une valeur autorisée",
	expectedString: "[label] doit être du texte",
	expectedNumber: "[label] doit être un nombre",
	expectedBoolean: "[label] doit être un booléen",
	expectedArray: "[label] doit être un tableau de valeur",
	expectedObject: "[label] doit être un objet",
	expectedConstructor: "[label] doit être de type [type]",
	regEx: [
		{msg: "[label] failed regular expression validation"},
		{exp: SimpleSchema.RegEx.Email, msg: "[label] must be a valid e-mail address"},
		{exp: SimpleSchema.RegEx.WeakEmail, msg: "[label] must be a valid e-mail address"},
		{exp: SimpleSchema.RegEx.Domain, msg: "[label] must be a valid domain"},
		{exp: SimpleSchema.RegEx.WeakDomain, msg: "[label] must be a valid domain"},
		{exp: SimpleSchema.RegEx.IP, msg: "[label] must be a valid IPv4 or IPv6 address"},
		{exp: SimpleSchema.RegEx.IPv4, msg: "[label] must be a valid IPv4 address"},
		{exp: SimpleSchema.RegEx.IPv6, msg: "[label] must be a valid IPv6 address"},
		{exp: SimpleSchema.RegEx.Url, msg: "[label] must be a valid URL"},
		{exp: SimpleSchema.RegEx.Id, msg: "[label] must be a valid alphanumeric ID"}
	],
	keyNotInSchema: "[key] ne peut pas être renseigné"
});



/** WEBPACK FOOTER **
 ** ./src/universal/collections/simpleSchema.config.js
 **/